import * as React from "react";

export type ErrorPageProps = {
	text: string | React.ReactElement;
};
export const ErrorPage = React.memo((props: ErrorPageProps) => {
	return <h1>{props.text}</h1>;
});
